<script setup>
import { ref, defineProps, onMounted, reactive } from 'vue';
import SkuPicker from 'src/components/SkuPicker';
import ProductCard from 'src/pages/list/components/ProductCard';
import { useRouter } from '../../utils/v2_helper/router';
import { useRecommendData } from './util';

const router = useRouter();

const { listData: list } = useRecommendData();

const show = ref(true);
const skuRef = ref();
const skuPickerProps = reactive({
  productId: '',
  tag: '',
  historyData: '',
});

function onHide() {
  router.replace({ name: 'products-list' });
}
function onOpenSku(it) {
  skuPickerProps.productId = it.id;
  skuPickerProps.tag = 'recommend';
  if (Array.isArray(it.defaultModifiers) && it.defaultModifiers?.length > 0) {
    skuPickerProps.historyData = encodeURI(JSON.stringify(it.defaultModifiers));
  }
  skuRef.value.visible = true;
}

function genQuery(it) {
  const query = { redirect: 'order-again', tag: 'recommend' };
  if (Array.isArray(it.defaultModifiers) && it.defaultModifiers?.length > 0) {
    query.historyData = encodeURI(JSON.stringify(it.defaultModifiers));
  }
  return query;
}

onMounted(() => {
  show.value = true;
});
</script>

<template>
  <q-dialog
    transition-show="xx"
    :value="show"
    maximized
    class="pc-width-pull-full"
    @hide="onHide"
  >
    <div class="history pc-width-pull-full">
      <div class="history-head">
        <i class="iconfont dm-arrow-left" @click="onHide" />
        <span bold>{{ $t('common.orderAgain') }}</span>
      </div>
      <div class="history-list">
        <div
          v-for="(it, index) in list"
          :key="index"
          class="history-list-item"
          @click="onOpenSku(it)"
        >
          <ProductCard
            class="item"
            :product="it"
            :extra="{ ...genQuery(it) }"
          />
        </div>
      </div>
      <sku-picker
        ref="skuRef"
        :product-id="skuPickerProps.productId"
        :tag="skuPickerProps.tag"
        :history-data="skuPickerProps.historyData"
      />
    </div>
  </q-dialog>
</template>

<style lang="scss">
.history {
  background: #fff;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: $grayBg-2;
  display: flex;
  flex-direction: column;
  &-head {
    font-size: $font-size-6;
    height: 64px;
    line-height: 64px;
    padding: 0 22px;
    background: #fff;
    .iconfont {
      font-size: inherit;
      margin-right: 20px;
    }
  }
  &-list {
    flex: 1;
    overflow: auto;
    padding-top: 8px;
    .item {
      pointer-events: none;
    }
  }
}
</style>
